module.exports = flarum.core.compat['components/Badge'];